import { createSelector } from "reselect";

export const selectPoem = (state) => state.poem;

export const selectIsLoading = createSelector(
  [selectPoem],
  (poem) => poem.isLoading
);
